"use client";

import { useTranslations } from "next-intl";
import AppleIcon from "@/assets/icons/apple.svg";
import GoogleIcon from "@/assets/icons/google.svg";
import { Button } from "@/components/ui/button";
import { AUTH_SECONDARY_BUTTON } from "@/features/auth/lib/auth-button-styles";
import {
  OAUTH_PROVIDERS,
  type OAuthProvider,
} from "@/features/auth/types/auth-flow.type";

const PROVIDER_ICONS = {
  google: GoogleIcon,
  apple: AppleIcon,
} as const;

type SocialSignInButtonsProps = {
  onSelect: (provider: OAuthProvider) => void;
  disabled?: boolean;
  /** Renders a single provider, used by the "account linked" step. */
  only?: OAuthProvider;
};

export const SocialSignInButtons = ({
  onSelect,
  disabled = false,
  only,
}: SocialSignInButtonsProps) => {
  const t = useTranslations("auth");
  const providers = only ? [only] : OAUTH_PROVIDERS;

  return (
    <div className="flex flex-col gap-4">
      {providers.map((provider) => {
        const Icon = PROVIDER_ICONS[provider];

        return (
          <Button
            className={AUTH_SECONDARY_BUTTON}
            disabled={disabled}
            key={provider}
            onClick={() => onSelect(provider)}
            type="button"
            variant="outline"
          >
            <Icon aria-hidden="true" className="size-6 shrink-0" />
            {t(`social.continueWith.${provider}`)}
          </Button>
        );
      })}
    </div>
  );
};
